import type {
  OnboardingEngineContext,
  OnboardingPromptDefinition,
  OnboardingPromptId,
} from "./types";

export function resolveNextOnboardingPrompt(
  ctx: OnboardingEngineContext,
  prompts: OnboardingPromptDefinition[],
): OnboardingPromptId | null {
  if (ctx.suppressAutoPrompts) return null;
  const eligible = prompts.filter((prompt) => prompt.isEligible(ctx));
  if (eligible.length === 0) return null;

  eligible.sort((a, b) => b.priority - a.priority);
  return eligible[0]?.id ?? null;
}

export function isOnboardingPromptEligible(
  promptId: OnboardingPromptId,
  ctx: OnboardingEngineContext,
  prompts: OnboardingPromptDefinition[],
): boolean {
  const prompt = prompts.find((entry) => entry.id === promptId);
  if (!prompt) return false;
  if (ctx.suppressAutoPrompts) return false;
  return prompt.isEligible(ctx);
}
